export default {
  allCategories: { en: 'All categories', he: 'כל הקטגוריות' },
  apply: { en: 'Apply', he: 'החל' },
  bestDeal: { en: 'Best Deal', he: 'העסקה הטובה ביותר' },
  categories: { en: 'Categories', he: 'קטגוריות' },
  catHomeDecor: { en: 'Home Decor', he: 'עיצוב הבית' },
  catBluetoothSpeakers: { en: 'Bluetooth Speakers', he: 'רמקולי Bluetooth' },
  catSmartphones: { en: 'Smartphones', he: 'סמארטפונים' },
  catPetsSupplies: { en: 'Pets Supplies', he: 'ציוד לחיות' },
  catElectronics: { en: 'Electronics', he: 'אלקטרוניקה' },
  catDiy: { en: 'Do it yourself', he: 'עשה זאת בעצמך' },
  catFashionAccessories: { en: 'Fashion Accessories', he: 'אביזרי אופנה' },
  catKidsToys: { en: 'Kids Toys', he: 'צעצועים לילדים' },
  clearAll: { en: 'Clear all', he: 'נקה הכל' },
  hideAccessories: { en: 'Hide accessories (experimental)', he: 'הסתר אביזרים (נסיוני)' },
  hideAccessoriesHint: {
    en: 'Hides parts, covers and add-ons that are not the main product you searched for.',
    he: 'מסתיר חלקים, כיסויים ואביזרים שאינם המוצר העיקרי שחיפשת.',
  },
  condition: { en: 'Condition', he: 'מצב מוצר' },
  filters: { en: 'Filters', he: 'סינון' },
  maxPrice: { en: 'Max price', he: 'מחיר מקסימלי' },
  minPrice: { en: 'Min price', he: 'מחיר מינימלי' },
  priceRange: { en: 'Price range', he: 'טווח מחירים' },
  priceHistogramHint: {
    en: 'Green = cheap, blue = mid, red = pricey. Taller bars = more products. Click to jump.',
    he: 'ירוק = זול, כחול = אמצע, אדום = יקר. עמודות גבוהות = יותר מוצרים. לחץ לקפיצה.',
  },
  filterByPrice: { en: 'Filter by price', he: 'סנן לפי מחיר' },
  productsInBracket: { en: '{count} products', he: '{count} מוצרים' },
  priceLowToHigh: { en: 'Low → High', he: 'נמוך → גבוה' },
  new: { en: 'New', he: 'חדש' },
  noResults: { en: 'No products match your filters', he: 'אין מוצרים שתואמים לסינון' },
  refurbished: { en: 'Refurbished', he: 'מחודש' },
  search: { en: 'Search', he: 'חיפוש' },
  searchPlaceholder: { en: 'What would you like to buy?', he: 'מה תרצה לקנות?' },
  shipTo: { en: 'Shipping to', he: 'משלוח אל' },
  shipToHint: {
    en: 'Choose where packages ship to and which currency to display prices in',
    he: 'בחרו לאן יישלחו החבילות ובאיזה מטבע להציג מחירים',
  },
  storeCountry: { en: 'Store country', he: 'מדינת חנות' },
  storeCountryHint: {
    en: 'Filter results by the country where the store is located',
    he: 'סנן תוצאות לפי המדינה שבה החנות נמצאת',
  },
  currency: { en: 'Currency', he: 'מטבע' },
  sortBy: { en: 'Sort by', he: 'מיון לפי' },
  sortLowest: { en: 'Price: Low to High', he: 'מחיר: מהנמוך לגבוה' },
  sortHighest: { en: 'Price: High to Low', he: 'מחיר: מהגבוה לנמוך' },
  sortCompopo: { en: 'Best Match', he: 'התאמה מיטבית' },
  stores: { en: 'Stores', he: 'חנויות' },
  used: { en: 'Used', he: 'משומש' },
  verifiedPrice: { en: 'Verified Price', he: 'מחיר מאומת' },
  watchlist: { en: 'Watchlist', he: 'מעקב' },
  showAllStores: { en: 'Show all ({count})', he: 'הצג הכל ({count})' },
  showLess: { en: 'Show less', he: 'הצג פחות' },
  openFilters: { en: 'Filters', he: 'סינון' },
  priceScrollNav: { en: 'Price navigation', he: 'ניווט לפי מחיר' },
  emptyWatchlistTitle: { en: 'Your watchlist is empty', he: 'רשימת המעקב ריקה' },
  emptyWatchlistMessage: {
    en: 'Tap the heart on any product to save it here.',
    he: 'לחצו על הלב בכרטיס מוצר כדי להוסיף אותו לכאן.',
  },
  emptyFiltersTitle: { en: 'No matches found', he: 'לא נמצאו תוצאות' },
  emptyFiltersMessage: {
    en: 'Try adjusting your filters or search for something else.',
    he: 'נסו לשנות את הסינון או לחפש משהו אחר.',
  },
  carouselPrev: { en: 'Previous', he: 'הקודם' },
  carouselNext: { en: 'Next', he: 'הבא' },
  expPriceTitle: { en: 'Global comparison', he: 'השוואה גלובלית' },
  expPriceSubtitle: {
    en: 'Over 10 eBay and AliExpress stores from around the world',
    he: 'מעל 10 חנויות eBay ו-AliExpress מכל העולם',
  },
  expTruckTitle: { en: 'Shipping included', he: 'משלוח כלול' },
  expTruckSubtitle: {
    en: 'The truck icon means the price includes shipping',
    he: 'אייקון משאית מציין שהמחיר כולל משלוח',
  },
  expAirplaneTitle: { en: 'Shipped to you', he: 'נשלח אליכם' },
  expAirplaneSubtitle: {
    en: 'All products shown ship to your destination',
    he: 'כל המוצרים המוצגים נשלחים ליעד שלכם',
  },
  expDollarTitle: { en: 'Lowest price', he: 'המחיר הזול ביותר' },
  expDollarSubtitle: {
    en: 'Our search engine points to the cheapest store',
    he: 'מנוע חיפוש שמצביע על האתר הזול ביותר',
  },
  expPaymentTitle: { en: 'Secure payment', he: 'תשלום מאובטח' },
  expPaymentSubtitle: {
    en: 'Payment is made with the marketplaces, not with Compopo',
    he: 'התשלום מתבצע מול הרשתות, לא מול קומפופו',
  },
  expSortingTitle: { en: 'Sort by price', he: 'מיון לפי מחיר' },
  expSortingSubtitle: {
    en: 'Find the best deal quickly',
    he: 'מצאו את המחיר המשתלם ביותר בקלות',
  },
  compareIndexTitle: { en: 'Popular Price Comparisons', he: 'השוואות מחירים פופולריות' },
  compareIndexSubtitle: {
    en: 'Your Global Destination for the Best Prices',
    he: 'היעד הגלובלי שלכם למחירים הטובים ביותר',
  },
  compareIndexCompareCta: { en: 'Compare prices', he: 'השוואת מחירים' },
  compareIndexTabGaming: { en: 'Gaming', he: 'גיימינג' },
  compareIndexTabPhones: { en: 'Phones', he: 'סמארטפונים' },
  compareIndexTabHome: { en: 'Home', he: 'לבית' },
  compareIndexTabMore: { en: 'More', he: 'עוד' },
  compareIndexTabAudio: { en: 'Audio', he: 'אודיו' },
  compareIndexTabComputing: { en: 'Computers', he: 'מחשבים' },
  compareIndexTabFashion: { en: 'Fashion', he: 'אופנה' },
  compareIndexTabSports: { en: 'Sports', he: 'ספורט וכושר' },
  compareIndexTabBeauty: { en: 'Beauty', he: 'יופי וטיפוח' },
  compareIndexTabBaby: { en: 'Baby & Kids', he: 'תינוקות וילדים' },
  compareIndexTabPets: { en: 'Pets', he: 'חיות מחמד' },
  compareIndexTabKitchen: { en: 'Kitchen', he: 'מטבח' },
  compareIndexTabTools: { en: 'Tools', he: 'כלי עבודה' },
  compareIndexTabWatches: { en: 'Watches', he: 'שעונים' },
  compareIndexTabToys: { en: 'Toys', he: 'צעצועים' },
  compareIndexMoreTitle: { en: 'Browse by Category', he: 'קטגוריות נוספות' },
  compareIndexDescription: {
    en: 'Compare prices on popular products from eBay, AliExpress and Amazon. Find the lowest price including shipping.',
    he: 'השוו מחירים על מוצרים פופולריים מ-eBay, AliExpress ו-Amazon. מצאו את המחיר הזול ביותר כולל משלוח.',
  },
  compareIndexSubtext: {
    en: 'Prices from eBay, AliExpress and Amazon including shipping',
    he: 'השוואת מחירים מ-eBay, AliExpress ו-Amazon כולל משלוח',
  },
  homeFeaturedTitle: { en: 'Popular comparisons', he: 'השוואות פופולריות' },
  homeFeaturedSubtitle: {
    en: 'Jump straight to price comparisons on products people search for most.',
    he: 'קפיצה ישירה להשוואות מחירים על המוצרים הכי מבוקשים.',
  },
  homeViewAllComparisons: { en: 'View all comparisons', he: 'כל ההשוואות' },
  homePopularSearches: { en: 'Popular searches', he: 'חיפושים פופולריים' },
  homeCategoryMore: { en: 'More', he: 'עוד' },
  homeCategoryExplore: { en: 'Explore comparisons', he: 'גלה השוואות' },
  homeStoresLabel: { en: 'Compare prices from', he: 'השוואת מחירים מ' },
  homeHotDealsTitle: { en: 'Hot deals', he: 'עסקאות חמות' },
  homeHotDealsHint: {
    en: 'Live prices including shipping · refreshed once a day',
    he: 'מחירים כולל משלוח · מתעדכן פעם ביום',
  },
  homeHotDealsLoading: {
    en: 'Loading today\'s best deals...',
    he: 'טוען את העסקאות החמות של היום...',
  },
  homeHotDealsEmpty: {
    en: 'Hot deals are warming up. Try again in a moment.',
    he: 'העסקאות החמות בדרך. נסו שוב בעוד רגע.',
  },
};
